import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { ButtonComponent, DropdownComponent, IconComponent, SimpleFileSelectorInputComponent } from '@shared/components/ui';
import { EmailMessagesComposition } from '@shared/compositions/email-messages.composition';
import { ReactiveFormsModule } from '@angular/forms';
import { FormErrorComponent } from '@shared/components';
import { isMobileView } from '@core/utils';
import { EmailMessageEntity } from '@core/entities';

@Component({
  selector: 'app-email-message-form',
  imports: [CommonModule, DropdownComponent, TranslateModule, NgSelectModule, ButtonComponent, ReactiveFormsModule, FormErrorComponent, IconComponent, SimpleFileSelectorInputComponent],
  templateUrl: './email-message-form.component.html',
  styleUrls: ['./email-message-form.component.scss'],
})
export class EmailMessageFormComponent extends EmailMessagesComposition {
  @Input() isDraft = false;

  acceptFileTypes = '.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv,.jpeg,.jpg,.png';
  protected readonly isMobileView = isMobileView();

  constructor() {
    super();
    this._initForm();
  }

  @Input() set emailMessage(value: EmailMessageEntity) {
    this.selectedEmailMessage = value;
    if (this.selectedEmailMessage) {
      this._patchForm();
    }
  }

  close() {
    if (isMobileView()) {
      this._bottomSheetService.close();
    } else {
      this._dialogService.closeAll();
    }
  }
}
